export default __webpack_public_path__ + "static/media/BasicR.edc1f2ba.pdf";